<div class="game-intro">
  <!-- ¿Qué es? -->
  @if (mode() === 'what-is') {
    @if (content().whatIs; as whatIs) {
      <div class="game-intro__row">
        <div class="game-intro__text">
          <h2 class="game-intro__heading">{{ whatIs.heading }}</h2>
          @for (p of whatIs.paragraphs; track $index) {
            <p class="game-intro__paragraph">{{ p }}</p>
          }
        </div>
        @if (whatIs.imageUrl) {
          <div class="game-intro__media">
            <img
              [src]="whatIs.imageUrl"
              [alt]="whatIs.imageAlt"
              class="game-intro__image"
              loading="lazy"
            />
          </div>
        }
      </div>
    }
  }

  <!-- ¿Cómo jugar? -->
  @if (mode() === 'how-to-play') {
    @if (content().howToPlay; as howToPlay) {
      <div class="game-intro__row game-intro__row--reversed">
        <div class="game-intro__text">
          <h2 class="game-intro__heading">{{ howToPlay.heading }}</h2>
          @for (p of howToPlay.paragraphs; track $index) {
            <p class="game-intro__paragraph">{{ p }}</p>
          }
        </div>
        @if (howToPlay.videoUrl || howToPlay.imageUrl) {
          <div class="game-intro__media">
            @if (howToPlay.videoUrl; as videoUrl) {
              <app-game-video-embed [videoUrl]="videoUrl" [caption]="howToPlay.videoCaption" />
            } @else {
              <img
                [src]="howToPlay.imageUrl"
                [alt]="howToPlay.imageAlt"
                class="game-intro__image"
                loading="lazy"
              />
            }
          </div>
        }
      </div>
    }
  }
</div>
